import type { Options } from 'nouislider';

export const DEFAULT_CONFIGS: Options = {
  start: [0],
  range: {
    min: [0],
    max: [10],
  },
};
